import { AlertMessage } from "../components/alert-message";
import { toast } from "../components/toast-notifications/toast-container";

export type AlertAutoClosingProps = AlertMessage & {
  className?: string | null;
  duration?: number | null;
};

export const showAutoClosingAlert = (autoClosingAlertProps: AlertAutoClosingProps | undefined) => {
  if (autoClosingAlertProps === undefined) {
    return;
  }

  const { duration, ...alertMessage } = autoClosingAlertProps;
  const { type, message: msg, description } = alertMessage;

  // Use custom toast API for React 19 compatibility
  const toastType = type as "success" | "error" | "info" | "warning";
  if (toastType in toast) {
    toast[toastType](String(msg), description ? String(description) : undefined, duration ?? 1.2);
  }
};

export const getAutoClosingAlertProps = (
  autoClosingAlertProps?: AlertAutoClosingProps | undefined
) => {
  if (autoClosingAlertProps === undefined) {
    return undefined;
  }
  const { className, duration, ...alertMessage } = autoClosingAlertProps;
  return {
    duration: duration ?? 1.2,
    message: alertMessage.message,
    description: alertMessage.description,
    ...(className ? { className } : {}),
  };
};
